import { abbreviateNumber } from '@mm/utils';
import React from 'react';
import iOSSrc from './icons/iOS.png';
import chromeSrc from './icons/chrome.png';
import firefoxSrc from './icons/firefox.png';
import adBlockersSrc from './icons/ad-blockes.png';
import coockiesSrc from './icons/cookies.png';
import { ReactComponent as AudiencesIcon } from 'assets/audiences-icon.svg';
import styles from './SignalLossDiagram.module.css';
import classNames from 'classnames';

export const SignalLossDiagram = ({
  website,
  traffic,
  isMobile,
}: {
  website: string;
  traffic: number;
  isMobile?: boolean;
}) => {
  const toFixed = 2;

  const lossBanner = (
    <div
      className={classNames(styles.absoluteBlock, styles.lossBlock, {
        [styles.initialPosition]: isMobile,
      })}
    >
      <span className={styles.heading}>You lost 71%</span>
      <span className={styles.text}>
        of your potential Signal to Meta for optimal ad performance
      </span>
    </div>
  );

  const advantageBanner = (
    <div
      className={classNames(styles.absoluteBlock, styles.advantageBlock, {
        [styles.initialPosition]: isMobile,
      })}
    >
      <span className={styles.heading}>We can restore this signal</span>
    </div>
  );

  return (
    <div className={styles.container}>
      <div className={styles.greenBlock} style={{ width: '100%' }}>
        <AudiencesIcon className={styles.audiencesIcon} />
        <div>
          <div className={styles.heading}>{abbreviateNumber(traffic)}</div>
          <div className={styles.text}>
            <span className={styles.link}>{website}</span>
            ’s monthly visitors
          </div>
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.redBlock} style={{ width: '70%' }}>
          <span className={styles.heading}>
            -{abbreviateNumber(traffic * 0.4, toFixed)}{' '}
          </span>
          <span className={styles.text}>lost</span>
          <span className={styles.label} style={{ right: '-30px' }}>
            <img src={iOSSrc} alt="iOS" />
            {!isMobile && <span> IOS 14-17 blocks</span>}
          </span>
        </div>
      </div>
      <div className={styles.greenBlock} style={{ width: '70%' }}>
        <div>
          <div className={styles.heading}>
            {abbreviateNumber(traffic * 0.6, toFixed)}
          </div>
          <div className={styles.text}>events discovered</div>
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.redBlock} style={{ width: '60%' }}>
          <span className={styles.heading}>
            -{abbreviateNumber(traffic * 0.15, toFixed)}{' '}
          </span>
          <span className={styles.text}>lost</span>
        </div>
        <span className={styles.label} style={{ right: '20px' }}>
          <img src={chromeSrc} alt="Chrome" />
          {!isMobile && <span>Chrome blocks</span>}
        </span>
      </div>

      <div className={styles.greenBlock} style={{ width: '60%' }}>
        <div>
          <div className={styles.heading}>
            {abbreviateNumber(traffic * 0.45, toFixed)}
          </div>
          <div className={styles.text}>events left</div>
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.redBlock} style={{ width: '50%' }}>
          <span className={styles.heading}>
            -{abbreviateNumber(traffic * 0.1, toFixed)}{' '}
          </span>
          <span className={styles.text}>lost</span>
        </div>
        <span className={styles.label} style={{ right: '65px' }}>
          <img src={firefoxSrc} alt="FireFox" />
          {!isMobile && <span> Firefox blocks</span>}
        </span>
      </div>
      <div className={styles.greenBlock} style={{ width: '50%' }}>
        <div>
          <div className={styles.heading}>
            {abbreviateNumber(traffic * 0.35, toFixed)}
          </div>
          <div className={styles.text}>events left</div>
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.redBlock} style={{ width: '40%' }}>
          <span className={styles.heading}>
            -{abbreviateNumber(traffic * 0.04, toFixed)}{' '}
          </span>
          <span className={styles.text}>lost</span>
        </div>
        <span className={styles.label} style={{ right: '120px' }}>
          <img src={adBlockersSrc} alt="AdBlockers" />
          {!isMobile && <span>AdBlockers</span>}
        </span>
      </div>

      <div style={{ position: 'relative', width: '40%' }}>
        <div className={styles.greenBlock}>
          <div>
            <div className={styles.heading}>
              {abbreviateNumber(traffic * 0.31, toFixed)}
            </div>
            <div className={styles.text}>events left</div>
          </div>
        </div>
        {!isMobile && (
          <>
            {lossBanner}
            {advantageBanner}
          </>
        )}
      </div>

      <div className={styles.row}>
        <div className={styles.redBlock} style={{ width: '30%' }}>
          <span className={styles.heading}>
            -{abbreviateNumber(traffic * 0.02, toFixed)}{' '}
          </span>
          <span className={styles.text}>lost</span>
          <span className={styles.label} style={{ right: '10px' }}>
            <img src={coockiesSrc} alt="Cookies" />
            {!isMobile && <span> Cookies expiring and being deleted</span>}
          </span>
        </div>
      </div>
      <div style={{ position: 'relative', width: '30%' }}>
        <div className={styles.greenBlock}>
          <div>
            <div className={styles.heading}>
              {abbreviateNumber(traffic * 0.29, toFixed)}
            </div>
            <div className={styles.text}>events sent to Facebook</div>
          </div>
        </div>
        {!isMobile && (
          <div className={styles.absoluteBlock}>
            <span className={styles.heading}>only 29% </span>
            <span className={styles.text}>
              of your events have been sent to Facebook
            </span>
          </div>
        )}
      </div>
      {isMobile && (
        <div className={styles.mobileBanners}>
          {lossBanner}
          {advantageBanner}
        </div>
      )}
    </div>
  );
};
